import type { Account } from './models';

// Keep purchase assets (including inventory) while excluding money/control accounts.
export function canUsePurchaseAccount(account: Account, currency: string): boolean {
  if (!account.isActive || account.currency !== currency) return false;
  const excluded = new Set([
    'bank_checking', 'checking', 'savings', 'bank', 'cash', 'cash_on_hand',
    'petty_cash', 'clearing', 'payment_clearing', 'merchant_clearing', 'undeposited_funds', 'bank_import_review',
    'accounts_receivable', 'accounts_payable', 'sales_tax_payable', 'credit_card',
    'accumulated_depreciation', 'accumulated_amortization', 'allowance_for_doubtful_accounts',
  ]);
  if (excluded.has((account.systemKey ?? '').trim().toLowerCase()) ||
      excluded.has((account.subtype ?? '').trim().toLowerCase())) return false;
  return account.type === 'expense' || account.type === 'asset';
}
